import { gql } from "@apollo/client";

export const LIST_STUDENTS_QUERY = gql`
  query listStudents($limit: Int, $page: Int, $q: String, $sortBy: [SortFieldInput!], $filterTeacherId: Int) {
    students(limit: $limit, page: $page, q: $q, sortBy: $sortBy, filterTeacherId: $filterTeacherId) {
      __typename
      ... on StudentConnection {
        edges {
          node {
            id
            f_name
            l_name
            email
            dob
            last_seen
            google_id
            ad_id
            apple_unique_identifier
            managed_apple_id
            external_mis_id
            device_signature
            joined
            image
            created_at
            updated_at
            deleted_at
            devices {
              device_uuid
              device_signature
              device_name
              device_name_actual
              os_type_id
              os_version
              os_platform
              serial
              last_seen
              has_mg_app
              is_chrome_managed
            }
            tags {
              key
              value
            }
            grade {
              key
              value
            }
            #school {
            #  id
            #  name
            #}
          }
          # cursor
        }
        # edges
        pageInfo {
          totalCount
          count
          perPage
          currentPage
          totalPages

          hasNextPage
          hasPreviousPage
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;

export const STUDENT_VIEW_QUERY = gql`
  query GetStudent($id: ID!) {
    student(id: $id) {
      __typename
      ... on Student {
        id
        f_name
        l_name
        email
        dob
        last_seen
        google_id
        ad_id
        apple_unique_identifier
        managed_apple_id
        external_mis_id
        # device_signature # not available on single records
        # joined # not available on single records
        # image # not available on single records
        created_at
        updated_at
        deleted_at
        devices {
          device_uuid
          device_signature
          device_name
          device_name_actual
          has_mg_app
          os_type_id
          os_version
          os_platform
          serial
          last_seen
          is_chrome_managed
        }
        history {
          type
          description
          ts
          method
          object_id
          object_value
        }
        tags {
          key
          value
        }
        grade {
          key
          value
        }
        #school {
        #  id
        #  name
        #}
        image
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;

export const STUDENT_WEBFILTER_HISTORY_QUERY = gql`
  query GetStudentWebfilterHistory($id: ID!, $to: String!, $from: String!, $limit: Int!, $page: Int!, $q: String) {
    studentWebfilterHistories(id: $id, from: $from, to: $to, limit: $limit, page: $page, q: $q) {
      __typename
      ... on StudentWebfilterHistoryConnection {
        edges {
          node {
            id
            device_signature
            profile_uuid
            uri
            was_allowed
            config
            additional_information
            created_at
            updated_at
            uri_base
            uri_search_term
            matched_profile_uuid
            matched_category
            profile_name
            profile_school_id
          }
        }
        pageInfo {
          totalCount
          count
          perPage
          currentPage
          totalPages

          hasNextPage
          hasPreviousPage
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;

export const GRADES_QUERY = gql`
  query grades {
    grades {
      __typename
      ... on GradeConnection {
        edges {
          node {
            key
            value
          }
        }
        pageInfo {
          totalCount
          count
          perPage
          currentPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;

export const QUERY_STUDENTS_TO_ADD_TO_CLASS = gql`
  query studentsToAddToClass($q: String, $page: Int, $limit: Int) {
    studentsToAddToClass(q: $q, limit: $limit, page: $page) {
      __typename
      ... on StudentConnection {
        edges {
          node {
            # Enrollment search returns a minimal, non-sensitive projection
            # (id + name only). Do not request PII/device fields here — the API
            # strips them for students outside the teacher's roster.
            id
            f_name
            l_name
          }
        }
        pageInfo {
          totalCount
          count
          perPage
          currentPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
      }
      ... on NotQuiteSureProblem {
        message
      }
      ... on Problem {
        message
      }
    }
  }
`;
